import { render } from "./UserBills.vue?vue&type=template&id=394a4666"
import script from "./UserBills.vue?vue&type=script&lang=js"
export * from "./UserBills.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__